import React from 'react';
import { Text } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { CurrencyType, RefundAttemptDto } from '@tiendanube/common';
import { Domain } from '@tiendanube/common/src/enums';
import { DataList } from '@tiendanube/components';
import { CurrencyPrice } from 'commons/components';
import { useRefundCalculations } from 'domains/Orders/Orders/pages/hooks';

interface Attributes {
  refundAttempts: RefundAttemptDto[];
  defaultCurrency: CurrencyType;
}

function OrderRefundAmountRow({
  refundAttempts,
  defaultCurrency,
}: Readonly<Attributes>): React.JSX.Element | null {
  const { t } = useTranslation(Domain.ORDERS);
  const { calculateRefundedAmount } = useRefundCalculations(refundAttempts);
  const refundedAmount = calculateRefundedAmount(defaultCurrency);

  if (Number(refundedAmount.value) === 0) {
    return null;
  }

  return (
    <DataList.Row id="refund_details">
      <DataList.Cell width={70}>
        <Text color="neutral-textHigh">
          {t('orderSummaryCard.tableAmounts.refundedAmount')}
        </Text>
      </DataList.Cell>
      <DataList.Cell width={30}>
        <CurrencyPrice
          appearance="danger"
          price={-Number(refundedAmount.value)}
          currency={refundedAmount.currency}
          block
          textAlign="right"
        />
      </DataList.Cell>
    </DataList.Row>
  );
}
export default OrderRefundAmountRow;
